exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.planning[data-v-067dd428] {\n\tcursor: pointer;\n}\n.gap-1[data-v-067dd428] {\n\tgap: 10px;\n}\n", ""]);

// exports
